<template>
  <div v-if="hasLoaded && masterCampaign">
    <vs-prompt
      @accept="activateCampaign"
      title="Activate Campaign?"
      accept-text="Activate campaign"
      :active.sync="activatePopupActive"
    >
      <div>
        Are you sure you want to Activate this Campaign? It will be distributed
        to
        <b>{{ this.masterCampaign.venues.length }} venues</b>, which may then
        customize it. You will not be able to edit this campaign (step 1) any
        more. Nothing will be sent to any guests by proceeding to step 2.
      </div>
      <br />

      Specify a comment to be shown to the venues:
      <vs-textarea placeholder="Write a comment..." v-model="activateComment" />
    </vs-prompt>

    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/crm/campaigns"> HQ Campaigns</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">Edit campaign</li>
    </vs-breadcrumb>
    <form-wizard
      ref="form"
      color="rgba(var(--vs-primary), 1)"
      :title="`${masterCampaign.title}`"
      :subtitle="
        'Status: ' + masterStatusObject(masterCampaign.masterStatus).text
      "
      :startIndex="curStatusIndex"
    >
      <!-- tab 1 content -->
      <tab-content title="Campaign setup" lazy="true">
        <vs-row vs-justify="center">
          <vs-button
            @click="
              onSave();
              activatePopupActive = true;
            "
            :disabled="curStatusIndex != 0"
            class="my-4 py-5"
            >Start the campaign</vs-button
          >
        </vs-row>
        <master-campaign-step-1
          :master-campaign="masterCampaign"
          :isEditable="
            isEditable && hasPermissionForActiveVenue('vp.crm.campaigns.edit')
          "
          v-on:onSave="onSave"
        />
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Campaign approval process" lazy="true">
        <vs-row vs-justify="center">
          <vs-button
            @click="goToStep3"
            :disabled="curStatusIndex != 1"
            class="my-4 py-5"
            >Go to send step</vs-button
          >
        </vs-row>
        <master-campaign-step-2
          :master-campaign="masterCampaign"
          v-on:onSave="onSave"
        />
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Send Campaign to guests" lazy="true">
        <div
          class="mt-4 mb-8 flex flex-col items-center"
          v-if="
            masterCampaign.approvedForSendingAction &&
            (masterCampaign.masterStatus == 'ApprovedForSending' ||
              masterCampaign.masterStatus == 'Completed')
          "
        >
          <h5>Campaign has been approved to be sent</h5>
          <div>
            At
            {{ masterCampaign.approvedForSendingAction.timestamp | formatDate }}
            by
            {{ masterCampaign.approvedForSendingAction.userDisplayName }}
          </div>
          <vs-tooltip
            class="mt-4"
            text="Retract the approval, and revert the campaign to status Active. Partially and fully sent campaings for the venues will not be sent multiple times by performing this action."
            v-if="masterCampaign.masterStatus == 'ApprovedForSending'"
          >
            <vs-button
              color="danger"
              :disabled="!hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
              @click="retractApproval"
              >Retract approval</vs-button
            >
          </vs-tooltip>
        </div>
        <vs-row vs-justify="center" v-else>
          <vs-button
            @click="approveSendingCampaign"
            :disabled="
              masterCampaign.masterStatus != 'Active' ||
              numApprovedVenueCampaigns == 0 ||
              !hasPermissionForActiveVenue('vp.crm.campaigns.edit')
            "
            class="my-4 py-5"
            >Approve sending campaign</vs-button
          >
        </vs-row>
        <master-campaign-step-3
          :master-campaign="masterCampaign"
          v-on:onSave="onSave"
        />
      </tab-content>

      <!-- tab 4 content -->
      <tab-content title="Statistics">
        <master-campaign-step-4
          v-if="
            masterCampaign.masterStatus == 'ApprovedForSending' ||
            masterCampaign.masterStatus == 'Completed'
          "
          :master-campaign="masterCampaign"
        />
      </tab-content>

      <!-- <template slot="step" scope="props">
        <wizard-step
          :tab="props.tab"
          :transition="props.transition"
          :key="props.tab.title"
          :index="props.index"
        >
          <feather-icon v-if="props.tab == 0" icon="EditIcon" svgClasses="h-6 w-6" class="ml-1" />
        </wizard-step>
      </template> -->

      <!-- Removes footer -->
      <template slot="footer">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer- right"></div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MasterCampaignStep1 from "./Components/MasterCampaign/MasterCampaignStep1.vue";
import MasterCampaignStep2 from "./Components/MasterCampaign/MasterCampaignStep2.vue";
import MasterCampaignStep3 from "./Components/MasterCampaign/MasterCampaignStep3.vue";
import MasterCampaignStep4 from "./Components/MasterCampaign/MasterCampaignStep4.vue";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import campaignMixin from "@/views/mixins/campaignMixin";
import ActionTimeline from "../Automations/Automation/Actions/ActionTimeline.vue";

export default {
  mixins: [campaignMixin],
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    MasterCampaignStep1,
    MasterCampaignStep2,
    MasterCampaignStep3,
    MasterCampaignStep4,
    ActionTimeline,
  },
  data() {
    return {
      hasLoaded: false,

      activatePopupActive: false,
      activateComment: "",
    };
  },
  async mounted() {},
  watch: {
    masterCampaign(newValue) {
      console.log("CHANGED", newValue);
      if (newValue.masterStatus == "ApprovedForSending")
        setTimeout(() => {
          this.$refs.form.activateAll();
        }, 1);
    },
  },
  methods: {
    async activateCampaign() {
      try {
        this.$vs.loading({ text: "Activating campaign..." });
        await this.$store.dispatch("masterCampaigns/activateCampaign", {
          id: this.masterCampaign.id,
          comment: this.activateComment,
        });
        this.$vs.notify({
          color: "green",
          title: "Campaign activated",
          text: "The campaign was successfully activated",
        });

        this.$refs.form.nextTab();
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign not activated",
          text: err,
          time: 4000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    goToStep3() {
      this.$refs.form.nextTab();
    },
    async approveSendingCampaign() {
      if (this.numApprovedVenueCampaigns == 0) return;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: `Are you sure you want to approve sending this Campaign? All venue campaigns will no longer be editable, and non-approved venue campaigns will be cancelled. It will be sent to ${this.numApprovedVenueCampaigns} venues.`,
        accept: async () => {
          try {
            this.$vs.loading({ text: "Approving HQ campaign..." });
            await this.$store.dispatch(
              "masterCampaigns/approveCampaignForSending",
              this.masterCampaign.id
            );
            this.$vs.notify({
              color: "green",
              title: "Campaign approved",
              text: "The campaign was successfully approved to be sent",
            });

            this.$refs.form.nextTab();
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign not sent",
              text: err,
              time: 4000,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },
    async retractApproval() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: `Are you sure you want to retract the approval? No further emails or sms will be sent to the guests before the campaign is approved for sending again.`,
        accept: async () => {
          try {
            this.$vs.loading({ text: "Approving HQ campaign..." });
            await this.$store.dispatch(
              "masterCampaigns/retractApproval",
              this.masterCampaign.id
            );

            this.$vs.notify({
              color: "green",
              title: "Approval retracted",
              text: "The approval for the campaign was successfully retracted",
            });
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Cannot retract approval",
              text: err,
              time: 4000,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },
    async onSave() {
      console.log("Clicked save", this.masterCampaign);

      //Call service
      try {
        await this.$store.dispatch(
          "masterCampaigns/update",
          this.masterCampaign
        );
        this.$vs.notify({
          color: "green",
          title: "Campaign updated",
          text: "The campaign was successfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign updated",
          text: "Could not update the campaign",
          time: 4000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      masterCampaign: "masterCampaigns/masterCampaign",
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      activeVenue: "users/userId",
    }),
    curStatusIndex() {
      switch (this.masterCampaign.masterStatus) {
        case "Draft":
          return 0;
        case "Active":
          return 1;
        case "ApprovedForSending":
          return 2;
        case "Completed":
          return 3;
        default:
          return 0;
      }
    },
    numApprovedVenueCampaigns() {
      return this.venueCampaigns.filter((e) => e.status == "Approved").length;
    },
    isEditable() {
      return this.masterCampaign.masterStatus == "Draft";
    },
  },
  async created() {
    var masterCampaignId = this.$route.params.id;

    this.hasLoaded = false;
    await this.$store.dispatch("masterCampaigns/get", masterCampaignId);
    this.hasLoaded = true;
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}

.con-vs-dialog .vs-dialog {
  max-width: 800px !important;
  position: relative;
}
</style>
